// extracted by mini-css-extract-plugin
export default {"languageSwitcherContainer":"LanguageSwitch_languageSwitcherContainer__lwUZU","button":"LanguageSwitch_button__XYtL+","buttonPressed":"LanguageSwitch_buttonPressed__bZ8sl"};